<nav class="navbar">
	<div class="navbar navbar-left">
		<button class="btn btn-primary" (click)="ajouterPdp()">Ajouter un PDP</button>
	</div>
	<div class="navbar navbar-left">
		<button class="btn btn-primary" (click)="export()">Exporter</button>
	</div>
</nav>
<div class="mat-elevation-z8">
	<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
	<table mat-table matSort [dataSource]="dataSource" class="liste-pdps">
		<ng-container matColumnDef="id">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
			<td mat-cell *matCellDef="let pdp">
				<a href="#" title="Voir le détail de ce PDP" (click)="showPdpResume(pdp)">{{ pdp.id }}</a>
			</td>
		</ng-container>
	
		<ng-container matColumnDef="numeroPdp">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Numéro </th>
			<td mat-cell *matCellDef="let pdp">
				<a href="#" title="Voir le détail de ce PDP" (click)="showPdpResume(pdp)">{{ pdp.numeroPdp }}</a>
			</td>
		</ng-container>
	
		<ng-container matColumnDef="parcs">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Parcs </th>
			<td mat-cell *matCellDef="let pdp" title="{{ pdp.parcDescription }}"> {{ pdp.parcDescription | truncate:[18, '...'] }} </td>
		</ng-container>
	
		<ng-container matColumnDef="ouvrages">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Ouvrages </th>
			<td mat-cell *matCellDef="let pdp" title="{{ pdp.nomOuvrages }}"> {{ pdp.nomOuvrages | truncate:[24, '...'] }} </td>
		</ng-container>
	
		<ng-container matColumnDef="typePdp">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
			<td mat-cell *matCellDef="let pdp"> {{ pdp.typePdp | libelleTypePdp }} </td>
		</ng-container>
	
		<ng-container matColumnDef="entreprises">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Entreprises </th>
			<td mat-cell *matCellDef="let pdp" title="{{ pdp.nomEntreprises }}"> {{ pdp.nomEntreprises | truncate:[20, '...'] }} </td>
		</ng-container>
	
		<ng-container matColumnDef="description">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
			<td mat-cell *matCellDef="let pdp" title="{{ pdp.description }}"> {{ pdp.description | truncate:[20, '...']  }} </td>
		</ng-container>
	
		<ng-container matColumnDef="etat">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Etat </th>
			<td mat-cell *matCellDef="let pdp"> {{ pdp.etat | libelleEtatPdp:[pdp.obsolete] }} </td>
			<!-- new Date().getTime() > pdp.finValidite.getTime() -->
		</ng-container>
	
		<ng-container matColumnDef="dateDebut">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Date de début </th>
			<td mat-cell *matCellDef="let pdp"> {{ pdp.debutValidite | displayLocalDate }} </td>
		</ng-container>
	
		<ng-container matColumnDef="dateFin">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Date de fin </th>
			<td mat-cell *matCellDef="let pdp"> {{ pdp.finValidite | displayLocalDate }} </td>
		</ng-container>
	
		<ng-container matColumnDef="validite">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Validité </th>
			<td mat-cell *matCellDef="let pdp"> {{ pdp | libelleValiditePdp }} </td>
		</ng-container>
	
		<ng-container matColumnDef="joursAvantExpiration">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Jours avant expiration </th>
			<td mat-cell *matCellDef="let pdp" class="numberOfDaysRemaining"> {{ pdp.finValidite | displayNbJoursAvantExpiration }} </td>
		</ng-container>
	
		<ng-container matColumnDef="lien">
			<th mat-header-cell *matHeaderCellDef> Lien </th>
			<td mat-cell *matCellDef="let pdp">
				<a alt="Télécharger" title="Télécharger" target="_blank" href="{{ pdp.lien ? pdp.lien : '#' }}" *ngIf="pdp.lien" >
					<i class="fa fa-link"></i>
				</a>
			</td>
		</ng-container>
	
		<ng-container matColumnDef="actions">
			<th mat-header-cell *matHeaderCellDef>&nbsp;</th>
			<td mat-cell *matCellDef="let pdp" class="actions">
				<a href="#" title="{{ pdp | actionTitleForPdp:['Signer'] }}" 
					(click)="openSignatairesDialog(pdp)" *ngIf="pdp.parcActif && pdp.etat !== 3" 
					[ngClass]= "{'text-info': pdp.etat === 0, 'partiallySignedPdp': pdp.etat === 2, 'signedPdp': pdp.etat === 1}" >
					<i class="fa-regular fa-circle-check fa-lg"></i>
				</a>
				<a href="#" title="{{ pdp | actionTitleForPdp:['Gérer les intervenants'] }}" class= "intervenants" 
					(click)="openDialogForIntervenants(pdp)" *ngIf="pdp.parcActif && pdp.etat !== 3 && pdp.typePdp === 0 && pdp.versionTechnique >= versionInWhichValideursCanSignPdps" >
					<i class="fa fa-user fa-lg"></i>
				</a>
				<a href="#" title="{{ pdp | actionTitleForPdp:['Ajouter un lien'] }}" class= "lien" 
					(click)="openDialogForPdpLink(pdp)" *ngIf="pdp.parcActif" >
					<i class="fa fa-paperclip fa-lg"></i>
				</a>
				<a href="#" title="{{ pdp | actionTitleForPdp:['Générer le PDF'] }}" class="genererPdf" 
					(click)="openDialogForGeneration(pdp)" *ngIf="pdp.etat !== 3 && !pdp.obsolete && pdp.parcActif" >
					<i class="fa fa-download fa-lg"></i>
				</a>
				<a href="#" title="{{ pdp | actionTitleForPdp:['Modifier'] }}" class="modifier" 
					(click)="edit(pdp)" *ngIf="pdp.parcActif" >
					<i class="fa-regular fa-pen-to-square fa-lg"></i>
				</a>
				<a href="#" title="{{ pdp | actionTitleForPdp:['Dupliquer'] }}" (click)="duplicate(pdp)" *ngIf="pdp.parcActif" >
					<i class="fa fa-clone fa-lg"></i>
				</a>
				<a href="#" title="{{ pdp | actionTitleForPdp:['Archiver'] }}" class="archiver" (click)="archiver(pdp)" *ngIf="pdp.parcActif" >
					<i class="fa fa-archive fa-lg"></i>
				</a>
				<a href="#" title="{{ pdp | actionTitleForPdp:['Supprimer'] }}" class="supprimer" (click)="supprimer(pdp)" *ngIf="pdp.parcActif " >
					<i class="fa fa-trash fa-lg"></i>
				</a>
 				<a href="#" title="{{ pdp | actionTitleForPdp:['Revalider ou Invalider'] }}" class= "refresh" 
					(click)="openDialogForPdpRefreshValidation(pdp)" *ngIf="pdp.parcActif && pdp.etat === 5 && pdp.referentParcId === user.id" >
					<i class="fa fa-refresh"></i>
				</a>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row 
			*matRowDef="let row; columns: displayedColumns;" 
			[ngClass]= "{
				'expiredPdp': row?.expired && row?.typePdp === 0, 
				'archivedPdp': row?.obsolete, 
				'invalidPdp': row?.etat === 6, 
				'inRectureModePdp': row?.etat === 5, 
				'signedPdp': row?.etat === 1 && !row?.obsolete, 
				'partiallySignedPdp': row?.etat === 2 && !row?.obsolete
			}"
		></tr>
	</table>
	<mat-paginator #paginator showFirstLastButtons [pageSizeOptions]="[5, 10, 20, 50]" [pageSize]="10" aria-label="Choisissez une page">
	</mat-paginator>
</div>

<pdp-resume [id]="'pdpResumeDialog'" [detailCommands]="resumeDialogCommands"></pdp-resume>
<gestion-signature-pdp-specifique [id]="'signatairesPdpSpecificDialog'" [signCommands]="dialogSignatairesPdpSpecificCommands" (pdpChanged)="onPdpChanged($event)"></gestion-signature-pdp-specifique>
<gestion-signature-pdp-general [id]="'signatairesPdpGeneralDialog'" [signCommands]="dialogSignatairesPdpGeneralCommands" (pdpChanged)="onPdpChanged($event)"></gestion-signature-pdp-general>
<pdp-manage-intervenants [id]="'pdpIntervenantsDialog'" [manageCommands]="manageIntervenantsCommands" (pdpChanged)="onPdpChanged($event)"></pdp-manage-intervenants>

<pdp-manage-link [id]="'pdpManageLinkDialog'" [manageCommands]="manageLinkCommands" (pdpChanged)="onPdpChanged($event)"></pdp-manage-link>

<pdp-generation [id]="'pdpGenerationDialog'" [generationCommands]="generationCommands"></pdp-generation>

<pdp-validation-refresh [id]="'pdpValidationRefreshDialog'" [refreshValidationCommands]="refreshValidationCommands" (pdpChanged)="onPdpChanged($event)"></pdp-validation-refresh>
 






















